import React from 'react';
import { Route, Redirect } from 'react-router-dom';

function PrivateRoute({ children, ...rest }) {
	return (
		<Route
			{...rest}
			render={({ location, ...restRouteProps }) => {
				const params = new URLSearchParams(window.location.search);
				if (params.get('code')) {
					location.state = {
						searchToken: params.get('code')
					};
					return React.cloneElement(children, location);
				} else {
					return <Redirect to="/error" />;
				}
			}}
		/>
	);
}
export default PrivateRoute;
